document.addEventListener("DOMContentLoaded", function() {
  var tabs = document.querySelectorAll('.tab-link');
  var tabContents = document.querySelectorAll('.tab-content');

  function isEmpty(content) {
    return !content || content.innerHTML.trim() === "";
  }

  function openFirstAvailableTab() {
    let opened = false;
    
    tabs.forEach((tab, index) => {
      let content = tabContents[index];
      
      if (!isEmpty(content) && !opened) {
        tab.classList.add('current');
        content.classList.add('current');
        opened = true;
      } else {
        tab.classList.remove('current');
        content.classList.remove('current');
      }
    });
  }

  openFirstAvailableTab();

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function() {
      tabs.forEach((t, i) => {
        t.classList.remove('current');
        tabContents[i].classList.remove('current');
      });

      tab.classList.add('current');
      tabContents[index].classList.add('current');
    });
  });
});


    document.addEventListener("DOMContentLoaded", function () {
    const playPauseBtns = document.querySelectorAll(".play-pause-btn");

    playPauseBtns.forEach((btn) => {
      const video = btn.closest(".video-wrapper").querySelector("video");

      btn.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          btn.classList.add("active");
        } else {
          video.pause();
          btn.classList.remove("active");
        }
      });

      video.addEventListener("ended", function () {
        btn.classList.remove("active");
      });
    });
  });


"use strict";

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
 
  var defaultSettings = {
    pagination: "#AjaxinatePagination",
    method: "scroll",
    container: "#AjaxinateLoop",
    offset: 0,
    loadingText: "Loading",
    callback: null,
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize =
  function initializeTheCorrectFunctionsBasedOnTheMethod() {
    // Find and initialise the correct function based on the method set in the config
    if (this.containerElement) {
      var initializers = {
        click: this.addClickListener,
        scroll: this.addScrollListeners,
      };
      initializers[this.settings.method]();
    }
  };

Ajaxinate.prototype.addScrollListeners =
  function addEventListenersForScrolling() {
    if (this.paginationElement) {
      document.addEventListener("scroll", this.checkIfPaginationInView);
      window.addEventListener("resize", this.checkIfPaginationInView);
      window.addEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      );
    }
  };

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener(
        "click",
        this.stopMultipleClicks
      );
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top =
    this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom =
    this.paginationElement.getBoundingClientRect().bottom +
    this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function loadMore() {
  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function success() {
    if (!this.request.responseXML) {
      return;
    }
    if (!this.request.readyState === 4 || !this.request.status === 200) {
      return;
    }

    var newContainer = this.request.responseXML.querySelectorAll(
      this.settings.container
    )[0];
    var newPagination = this.request.responseXML.querySelectorAll(
      this.settings.pagination
    )[0];

    this.containerElement.insertAdjacentHTML(
      "beforeend",
      newContainer.innerHTML
    );

    if (typeof newPagination === "undefined") {
      this.removePaginationElement();
    } else {
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (
        this.settings.callback &&
        typeof this.settings.callback === "function"
      ) {
        this.settings.callback(this.request.responseXML);
      }

      this.initialize();
    }
  }.bind(this);

  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.removePaginationElement =
  function removePaginationElement() {
    this.paginationElement.innerHTML = "";
    this.destroy();
  };

Ajaxinate.prototype.removeScrollListener =
  function removeScrollEventListener() {
    document.removeEventListener("scroll", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener(
      "orientationchange",
      this.checkIfPaginationInView
    );
  };

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  // This method is used to unbind event listeners from the DOM
  // This function is called manually to destroy "this" Ajaxinate instance
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  destroyers[this.settings.method]();
  return this;
};


const radioButtons = document.querySelectorAll('input[type="radio"][data-selling-plan-group-id]');
radioButtons.forEach(button => {
    button.addEventListener('click', function(event) {
        const groupId = event.target.getAttribute('data-selling-plan-group-id');
        
        document.querySelector('.shopify_subscriptions_purchase_option_wrapper').style.setProperty('border', '0px solid #009175', 'important');
        
        const divs = document.querySelectorAll('.shopify_subscriptions_app_block_label');
        divs.forEach((div, index) => {
            if (index >= 1 && index <= 2) { 
                div.style.setProperty('border', '2px solid #009175', 'important');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const radioButton = document.querySelector('input[type="radio"][data-radio-type="one_time_purchase"]');
    radioButton.addEventListener('click', function() {
        document.querySelector('.shopify_subscriptions_purchase_option_wrapper').style.setProperty('border', '2px solid #009175', 'important');
        
        const divs = document.querySelectorAll('.shopify_subscriptions_app_block_label');
        divs.forEach((div, index) => {
            if (index >= 1 && index <= 2) { 
                div.style.setProperty('border', '0px solid #009175', 'important');
            }
        });
    });
});




